import Vue from 'vue'
import Router from 'vue-router'

import Auth from '@/components/Auth'
import Author from '@/components/Author'
import AuthorForm from '@/components/AuthorForm'
import AuthorPuzzles from '@/components/AuthorPuzzles'
import Authors from '@/components/Authors'
import BrandingTemplate from '@/components/BrandingTemplate'
import BrandingTemplateCreate from '@/components/BrandingTemplateCreate'
import BrandingTemplateEdit from '@/components/BrandingTemplateEdit'
import BrandingTemplates from '@/components/BrandingTemplates'
import Bundle from '@/components/Bundle'
import BundleCreate from '@/components/BundleCreate'
import BundleEdit from '@/components/BundleEdit'
import Bundles from '@/components/Bundles'
import Dashboard from '@/components/Dashboard'
import DebugAuth from '@/components/DebugAuth'
import EmailRecipient from '@/components/EmailRecipient'
import EmailRecipientForm from '@/components/EmailRecipientForm'
import EmailRecipients from '@/components/EmailRecipients'
import Email from '@/components/Email'
import EmailAttachment from '@/components/EmailAttachment'
import EmailForm from '@/components/EmailForm'
import EmailRecipientStats from '@/components/EmailRecipientStats'
import Emails from '@/components/Emails'
import EmailStats from '@/components/EmailStats'
import ExportSubscriptions from '@/components/ExportSubscriptions'
import FeaturedAuthors from '@/components/FeaturedAuthors'
import ImportContributors from '@/components/ImportContributors'
import ImportSubscriptions from '@/components/ImportSubscriptions'
import ImportNewsletterTypeSubscribers from '@/components/ImportNewsletterTypeSubscribers'
import Newsletter from '@/components/Newsletter'
import NewsletterCreate from '@/components/NewsletterCreate'
import NewsletterEdit from '@/components/NewsletterEdit'
import NewsletterRecipient from '@/components/NewsletterRecipient'
import Newsletters from '@/components/Newsletters'
import NewsletterCalendar from '@/components/NewsletterCalendar'
import NewsletterType from '@/components/NewsletterType'
import NewsletterTypeCreate from '@/components/NewsletterTypeCreate'
import NewsletterTypeEdit from '@/components/NewsletterTypeEdit'
import NewsletterTypeDigest from '@/components/NewsletterTypeDigest'
import NewsletterTypes from '@/components/NewsletterTypes'
import NewsletterTypeSubscriber from '@/components/NewsletterTypeSubscriber'
import NewsletterTypeSubscriberCreate from '@/components/NewsletterTypeSubscriberCreate'
import NewsletterTypeSubscriberEdit from '@/components/NewsletterTypeSubscriberEdit'
import NewsletterTypeSubscribers from '@/components/NewsletterTypeSubscribers'
import Partner from '@/components/Partner'
import Partners from '@/components/Partners'
import PartnerCreate from '@/components/PartnerCreate'
import PartnerEdit from '@/components/PartnerEdit'
import PartnerApp from '@/components/PartnerApp'
import PartnerApps from '@/components/PartnerApps'
import PartnerAppCreate from '@/components/PartnerAppCreate'
import PartnerAppEdit from '@/components/PartnerAppEdit'
import Profile from '@/components/Profile'
import Provider from '@/components/Provider'
import ProviderCreate from '@/components/ProviderCreate'
import ProviderEdit from '@/components/ProviderEdit'
import ProviderPuzzles from '@/components/ProviderPuzzles'
import Providers from '@/components/Providers'
import Purchase from '@/components/Purchase'
import PurchaseCreate from '@/components/PurchaseCreate'
import PurchaseEdit from '@/components/PurchaseEdit'
import PurchaseReports from '@/components/PurchaseReports'
import Purchases from '@/components/Purchases'
import PurchasableItem from '@/components/PurchasableItem'
import PurchasableItemCreate from '@/components/PurchasableItemCreate'
import PurchasableItemEdit from '@/components/PurchasableItemEdit'
import PurchasableItemPurchases from '@/components/PurchasableItemPurchases'
import PurchasableItems from '@/components/PurchasableItems'
import Puzzle from '@/components/Puzzle'
import PuzzleCreate from '@/components/PuzzleCreate'
import PuzzleEdit from '@/components/PuzzleEdit'
import Puzzles from '@/components/Puzzles'
import Settings from '@/components/Settings'
import Subscription from '@/components/Subscription'
import SubscriptionCreate from '@/components/SubscriptionCreate'
import SubscriptionEdit from '@/components/SubscriptionEdit'
import Subscriptions from '@/components/Subscriptions'
import SubscriptionStats from '@/components/SubscriptionStats'
import Tags from '@/components/Tags'
import TagCreate from '@/components/TagCreate'
import TagEdit from '@/components/TagEdit'
import TagPurchases from '@/components/TagPurchases'
import Tag from '@/components/Tag'
import User from '@/components/User'
import UserCreate from '@/components/UserCreate'
import UserDetailEdit from '@/components/UserDetailEdit'
import UserEdit from '@/components/UserEdit'
import UserPasswordResetRequest from '@/components/UserPasswordResetRequest'
import Users from '@/components/Users'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Purchases
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/bundles',
      name: 'bundles',
      component: Bundles
    },
    {
      path: '/bundles/:bundleId',
      name: 'bundle',
      component: Bundle,
      props: true
    },
    {
      path: '/create_bundles',
      name: 'create_bundle',
      component: BundleCreate
    },
    {
      path: '/edit_bundle/:bundleId',
      name: 'edit_bundle',
      component: BundleEdit,
      props: true
    },
    {
      path: '/newsletters',
      name: 'newsletters',
      component: Newsletters
    },
    {
      path: '/newsletters/:newsletterId',
      name: 'newsletter',
      component: Newsletter,
      props: true
    },
    {
      path: '/newsletter_calendar',
      name: 'newsletter_calendar',
      component: NewsletterCalendar,
      props: true
    },
    {
      path: '/:emailType/:emailId/attachments/:attachmentId',
      name: 'email_attachment',
      component: EmailAttachment,
      props: true
    },
    {
      path: '/newsletter_types',
      name: 'newsletter_types',
      component: NewsletterTypes
    },
    {
      path: '/newsletter_types/:newsletterTypeId',
      name: 'newsletter_type',
      component: NewsletterType,
      props: true
    },
    {
      path: '/edit_newsletter_type/:newsletterTypeId',
      name: 'edit_newsletter_type',
      component: NewsletterTypeEdit,
      props: true
    },
    {
      path: '/create_newsletter_type',
      name: 'create_newsletter_type',
      component: NewsletterTypeCreate
    },
    {
      path: '/create_newsletter',
      name: 'create_newsletter',
      component: NewsletterCreate
    },
    {
      path: '/edit_newsletter/:newsletterId',
      name: 'edit_newsletter',
      component: NewsletterEdit,
      props: true
    },
    {
      path: '/newsletter_types/:newsletterTypeId/newsletters',
      name: 'newsletter_type_newsletters',
      component: Newsletters,
      props: true
    },
    {
      path: '/newsletter_types/:newsletterTypeId/digest',
      name: 'newsletter_type_digest',
      component: NewsletterTypeDigest,
      props: true
    },
    {
      path: '/newsletter_types/:newsletterTypeId/subscribers',
      name: 'newsletter_type_subscribers',
      component: NewsletterTypeSubscribers,
      props: true
    },
    {
      path: '/newsletter_type_subscriber/:newsletterTypeSubscriberId',
      name: 'newsletter_type_subscriber',
      component: NewsletterTypeSubscriber,
      props: true
    },
    {
      path: '/create_newsletter_type_subscriber/:newsletterTypeId',
      name: 'create_newsletter_type_subscriber',
      component: NewsletterTypeSubscriberCreate,
      props: true
    },
    {
      path: '/edit_newsletter_type_subscriber/:newsletterTypeSubscriberId',
      name: 'edit_newsletter_type_subscriber',
      component: NewsletterTypeSubscriberEdit,
      props: true
    },
    {
      path: '/import_newsletter_type_subscribers/:newsletterTypeId',
      name: 'import_newsletter_type_subscribers',
      component: ImportNewsletterTypeSubscribers,
      props: true
    },
    {
      path: '/newsletters/:newsletterId/recipients',
      name: 'newsletter_recipients',
      component: EmailRecipients,
      props: true
    },
    {
      path: '/newsletters/:newsletterId/recipients/:newsletterRecipientId',
      name: 'newsletter_recipient',
      component: NewsletterRecipient,
      props: true
    },
    {
      path: '/newsletters/:newsletterId/stats',
      name: 'newsletter_stats',
      component: EmailStats,
      props: true
    },
    {
      path: '/emails/:emailId/stats',
      name: 'email_stats',
      component: EmailStats,
      props: true
    },
    {
      path: '/newsletters/:newsletterId/status/:status',
      name: 'newsletter_stats_by_status',
      component: EmailRecipientStats,
      props: true
    },
    {
      path: '/emails/:emailId/status/:status',
      name: 'email_stats_by_status',
      component: EmailStats,
      props: true
    },
    {
      path: '/emails/:emailId/confirm',
      name: 'email_confirm',
      component: Email,
      props: route => ({
        emailId: route.params.emailId,
        sendEmailConfirmation: true
      })
    },
    {
      path: '/newsletters/:newsletterId/confirm',
      name: 'newsletter_confirm',
      component: Newsletter,
      props: route => ({
        newsletterId: route.params.newsletterId,
        sendEmailConfirmation: true
      })
    },
    {
      path: '/emails',
      name: 'emails',
      component: Emails
    },
    {
      path: '/emails/:emailId',
      name: 'email',
      component: Email,
      props: true
    },
    {
      path: '/create_email',
      name: 'create_email',
      component: EmailForm,
      props: {
        actionType: 'create'
      }
    },
    {
      path: '/edit_email/:emailId',
      name: 'edit_email',
      component: EmailForm,
      props: true
    },
    {
      path: '/partners/',
      name: 'partners',
      component: Partners
    },
    {
      path: '/partners/:partnerId',
      name: 'partner',
      component: Partner,
      props: true
    },
    {
      path: '/create_partner',
      name: 'create_partner',
      component: PartnerCreate
    },
    {
      path: '/edit_partners/:partnerId',
      name: 'edit_partner',
      component: PartnerEdit,
      props: true
    },
    {
      path: '/partners/:partnerId/apps',
      name: 'partner_apps',
      component: PartnerApps,
      props: true
    },
    {
      path: '/partners/:partnerId/partner_apps/:partnerAppId',
      name: 'partner_app',
      component: PartnerApp,
      props: true
    },
    {
      path: '/partners/:partnerId/create_partner_app',
      name: 'create_partner_app',
      component: PartnerAppCreate,
      props: true
    },
    {
      path: '/partners/:partnerId/edit_partner_app/:partnerAppId',
      name: 'edit_partner_app',
      component: PartnerAppEdit,
      props: true
    },
    {
      path: '/profile/',
      name: 'profile',
      component: Profile
    },
    {
      path: '/providers/',
      name: 'providers',
      component: Providers
    },
    {
      path: '/provider/:providerId',
      name: 'provider',
      component: Provider,
      props: true
    },
    {
      path: '/create_provider/',
      name: 'create_provider',
      component: ProviderCreate
    },
    {
      path: '/edit_provider/:providerId',
      name: 'edit_provider',
      component: ProviderEdit,
      props: true
    },
    {
      path: '/provider/:providerId/puzzles',
      name: 'provider_puzzles',
      component: ProviderPuzzles,
      props: true
    },
    {
      path: '/purchases/:purchaseId',
      name: 'purchase',
      component: Purchase,
      props: true
    },
    {
      path: '/create_purchase',
      name: 'create_purchase',
      component: PurchaseCreate
    },
    {
      path: '/edit_purchase/:purchaseId',
      name: 'edit_purchase',
      component: PurchaseEdit,
      props: true
    },
    {
      path: '/purchases',
      name: 'purchases',
      component: Purchases
    },
    {
      path: '/purchase_reports',
      name: 'purchase_reports',
      component: PurchaseReports
    },
    {
      path: '/purchasable_item/:purchasableItemId',
      name: 'purchasable_item',
      component: PurchasableItem,
      props: true
    },
    {
      path: '/create_purchasable_item',
      name: 'create_purchasable_item',
      component: PurchasableItemCreate,
      props: true
    },
    {
      path: '/edit_purchasable_item/:purchasableItemId',
      name: 'edit_purchasable_item',
      component: PurchasableItemEdit,
      props: true
    },
    {
      path: '/purchasable_item/:purchasableItemId/purchases',
      name: 'purchasable_item_purchases',
      component: PurchasableItemPurchases,
      props: true
    },
    {
      path: '/purchasable_items',
      name: 'purchasable_items',
      component: PurchasableItems
    },
    {
      path: '/puzzles',
      name: 'puzzles',
      component: Puzzles
    },
    {
      path: '/puzzles/:puzzleId',
      name: 'puzzle',
      component: Puzzle,
      props: true
    },
    {
      path: '/puzzles/:puzzleId/edit',
      name: 'edit_puzzle',
      component: PuzzleEdit,
      props: true
    },
    {
      path: '/create_puzzle',
      name: 'create_puzzle',
      component: PuzzleCreate
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions,
      props: true
    },
    {
      path: '/create_subscription',
      name: 'create_subscription',
      component: SubscriptionCreate
    },
    {
      path: '/subscriptions/:subscriptionId',
      name: 'subscription',
      component: Subscription,
      props: true
    },
    {
      path: '/edit_subscription/:subscriptionId',
      name: 'edit_subscription',
      component: SubscriptionEdit,
      props: true
    },
    {
      path: '/stats/subscriptions',
      name: 'subscription_stats',
      component: SubscriptionStats,
      props: true
    },
    {
      path: '/email_recipients',
      name: 'all_email_recipients',
      component: EmailRecipients
    },
    {
      path: '/targeted_emails/:emailId/recipients',
      name: 'email_recipients',
      component: EmailRecipients,
      props: true
    },
    {
      path: '/email_recipient/:recipientId',
      name: 'email_recipient',
      component: EmailRecipient,
      props: true
    },
    {
      path: '/targeted_emails/:emailId/create_recipent',
      name: 'create_email_recipient',
      component: EmailRecipientForm,
      props: true
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/tags',
      name: 'tags',
      component: Tags
    },
    {
      path: '/tags/:tagId',
      name: 'tag',
      component: Tag,
      props: true
    },
    {
      path: '/create_tag',
      name: 'create_tag',
      component: TagCreate
    },
    {
      path: '/edit_tags/:tagId',
      name: 'edit_tag',
      component: TagEdit,
      props: true
    },
    {
      path: '/tag_purchases/:tagId',
      name: 'tag_purchases',
      component: TagPurchases,
      props: true
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/users/:userId',
      name: 'user',
      component: User,
      props: true
    },
    {
      path: '/authors',
      name: 'authors',
      component: Authors
    },
    {
      path: '/authors/:authorId',
      name: 'author',
      component: Author,
      props: true
    },
    {
      path: '/edit_author/:authorId',
      name: 'edit_author',
      component: AuthorForm,
      props: true
    },
    {
      path: '/authors/:authorId/puzzles',
      name: 'author_puzzles',
      component: AuthorPuzzles,
      props: true
    },
    {
      path: '/featured_authors',
      name: 'featured_authors',
      component: FeaturedAuthors,
      props: true
    },
    {
      path: '/create_user',
      name: 'create_user',
      component: UserCreate
    },
    {
      path: '/edit_user/:userId',
      name: 'edit_user',
      component: UserEdit,
      props: true
    },
    {
      path: '/edit_user_details/:userId',
      name: 'edit_user_details',
      component: UserDetailEdit,
      props: true
    },
    {
      path: '/debug_auth',
      name: 'debug_auth',
      component: DebugAuth
    },
    {
      path: '/debug_auth/:userId',
      name: 'debug_auth',
      component: DebugAuth,
      props: true
    },
    {
      path: '/export_subscriptions',
      name: 'export_subscriptions',
      component: ExportSubscriptions
    },
    {
      path: '/import_subscriptions',
      name: 'import_subscriptions',
      component: ImportSubscriptions
    },
    {
      path: '/settings/templates',
      name: 'branding_templates',
      component: BrandingTemplates
    },
    {
      path: '/settings/import_contributors',
      name: 'import_contributors',
      component: ImportContributors
    },
    {
      path: '/settings/templates/:brandingTemplateId',
      name: 'branding_template',
      component: BrandingTemplate,
      props: true
    },
    {
      path: '/settings/create_template',
      name: 'create_branding_template',
      component: BrandingTemplateCreate
    },
    {
      path: '/settings/edit_template/:brandingTemplateId',
      name: 'edit_branding_template',
      component: BrandingTemplateEdit,
      props: true
    },
    {
      path: '/sign_in',
      name: 'sign_in',
      component: Auth
    },
    {
      path: '/sign_out',
      name: 'sign_out',
      component: Auth,
      props: true
    },
    {
      path: '/request_password_reset',
      name: 'request_password_reset',
      component: UserPasswordResetRequest
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js